import { useState } from 'react'

import ConfirmationModal from 'src/ui/atoms/ConfirmationModal'
import Button from 'src/ui/atoms/Button'
import useProjectApi from '../../useProjectApi'

const SubscribeProject = ({ hasSubscription }: { hasSubscription: boolean }) => {
  const { subscribeProject, unsubscribeProject } = useProjectApi()
  const [subscribeModal, setSubscribeModal] = useState<boolean>(false)

  const handleSubscribeItem = async () => {
    setSubscribeModal(false)
    if (hasSubscription) {
      await unsubscribeProject()
    } else {
      await subscribeProject()
    }
  }

  return (
    <>
      <Button
        size="M"
        name={hasSubscription ? 'Unsubscribe' : 'Subscribe'}
        type={hasSubscription ? 'secondary' : 'primary'}
        onClick={() => setSubscribeModal(true)}
      />
      {subscribeModal && (
        <ConfirmationModal
          title="Are you sure you want to subscribe this project?"
          actions={
            <>
              <Button
                size="M"
                name="Cancel"
                type="secondary"
                onClick={() => setSubscribeModal(false)}
              />
              <Button
                size="M"
                name={hasSubscription ? 'Unsubscribe' : 'Subscribe'}
                onClick={handleSubscribeItem}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default SubscribeProject
